import http from "./httpService";
import jwtDecode from "jwt-decode";
import urlConstant from "../constants/url-constants";

const tokenKey = "token";

export async function loginByNationalCode(nationalCode) {
    const { data: result } = await http.post(urlConstant.getLoginByNationalCodeEndpoint(), { nationalCode }, http.getPublicConfig());
    localStorage.setItem(tokenKey, result.Token);
}

export async function loginBySerial(serial, serialType) {
    const { data: result } = await http.post(urlConstant.getLoginBySerialEndpoint(), { serial, serialType }, http.getPublicConfig());
    localStorage.setItem(tokenKey, result.Token);
}

export async function loginByMobile(mobile, password) {
    const { data: result } = await http.post(urlConstant.getLoginByMobileEndpoint(), { mobile, password }, http.getPublicConfig());
    localStorage.setItem(tokenKey, result.Token);
}

export async function forgetPassword(mobile) {
    const { data: result } = await http.post(urlConstant.getForgetPasswordEndpoint(), { mobile: mobile }, http.getPublicConfig());
    localStorage.setItem(tokenKey, result.Token);
}

export async function signUp(mobile, nationalCode, name, serialType, serial) {
    const { data: result } = await http.post(urlConstant.getSignUpEndpoint(), { mobile, nationalCode, name, serialType, serial }, http.getPublicConfig());
    localStorage.setItem(tokenKey, result.Token);
}

export function logout() {
    localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
    try {
        let jwt = localStorage.getItem(tokenKey);
        return jwtDecode(jwt);
    } catch (ex) {
        return null;
    }
}

export default {
    loginByNationalCode,
    loginBySerial,
    loginByMobile,
    signUp,
    logout,
    getCurrentUser,
    forgetPassword,
};
